import {AbstractIndexCommands} from "../../utility/abstract-index/abstract-index-commands";
import {TrunkNotice} from "@knust/api-interfaces";
import {
  createTrunkNotice,
  deleteTrunkNotice,
  loadTrunkNotices,
  restoreTrunkNotice,
  setTrunkNoticePage,
  setTrunkNoticeSort,
  setTrunkNoticeTerm,
} from './+state/trunk-notice.actions';
import {
  getAllTrunkNotice,
  getTrunkNoticePage,
  getTrunkNoticeSort,
  getTrunkNoticeTerm,
  getTrunkNoticeTotal,
} from './+state/trunk-notice.selectors';

export const trunkNoticesCommandMap: AbstractIndexCommands<TrunkNotice> = {
  getAll: getAllTrunkNotice,
  getTotal: getTrunkNoticeTotal,
  getPage: getTrunkNoticePage,
  setPage: setTrunkNoticePage,
  getTerm: getTrunkNoticeTerm,
  setTerm: setTrunkNoticeTerm,
  getSort: getTrunkNoticeSort,
  setSort: setTrunkNoticeSort,
  load: loadTrunkNotices,
  createElement: createTrunkNotice,
  deleteElement: deleteTrunkNotice,
  restoreElement: restoreTrunkNotice
}

export const trunkNoticesDisplayedColumns = ['id', 'label', 'deleteAction'];
export const trunkNoticesColumnConfig = [
  {
    name: 'ID',
    refName: 'id'
  },
  {
    name: 'Name',
    refName: 'label'
  }
];
